import clsx from 'clsx';
import { IAnyType } from 'common/types/common';

export const Textarea = ({
  className,
  classNameTextarea,
  disabled,
  errorMessage,
  helperText,
  isValid,
  label,
  name,
  onChange,
  onBlur,
  required,
  value,
}: IAnyType) => {
  return (
    <div className={clsx('mb-3 w-full', className)}>
      <div className="relative flex w-full flex-col">
        <textarea
          id={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          disabled={disabled}
          className={clsx(
            'autofill-transparent focus:ring-0; peer block min-h-[260px] w-full rounded-lg border border-neutral-300 bg-[#1C1027] bg-transparent p-3 pr-12 pt-12 md:pt-8 text-md text-white focus:border-primary focus:outline-none',
            classNameTextarea,
            { 'input-error': !!errorMessage, 'input-success': isValid },
          )}
          placeholder="  "
        />

        <label
          htmlFor={name}
          className="text-md absolute left-1 top-4 z-10 origin-[0] -translate-y-4 scale-[0.6] transform px-4 py-0.5 font-normal text-white opacity-90 duration-300 peer-placeholder-shown:top-1/4 peer-placeholder-shown:-translate-y-1/4 peer-placeholder-shown:scale-100 peer-focus:top-4 peer-focus:-translate-y-4 peer-focus:scale-[0.6] peer-focus:px-4"
          dangerouslySetInnerHTML={{ __html: `${required ? '* ' : ''}${label}` }}
        />
      </div>
      {!!errorMessage && (
        <div className="ml-2 mt-1.5 text-xs text-red-600">{errorMessage || 'Message'}</div>
      )}
      {!errorMessage && !!helperText && (
        <div className="ml-2 mt-1.5 text-xs text-white/55">{helperText}</div>
      )}
    </div>
  );
};
